import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const getNotificationCount = (userId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        
        var fdd = new FormData();
        fdd.append('userId', userId);

        axios({
          method : "POST",
          url :  api_url + "/GetNotificationCount",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadNotifications = (userId, incrementSize, lowerLimit) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        
        var fdd = new FormData();
        fdd.append('userId', userId);
   	    fdd.append('upperLimit', incrementSize);
   	    fdd.append('lowerLimit', lowerLimit); 

        axios({
          method : "POST",
          url :  api_url + "/DownloadNotifications",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}